import React from "react";

import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/src/components/ui/button";

import type { JSX, ReactNode } from "react";

interface SectionPanelProps {
  title: string;
  onBack: () => void;
  children: ReactNode;
}

function SectionPanel({
  title,
  onBack,
  children,
}: SectionPanelProps): JSX.Element {
  const { t } = useTranslation("editor-appearance");

  return (
    <React.Fragment>
      <div className="bg-muted flex h-[52px] shrink-0 items-center gap-2.5 border-b px-3.5">
        <Button
          className="text-muted-foreground h-[30px] shrink-0 gap-1.5 px-2 text-xs"
          onClick={onBack}
          size="sm"
          type="button"
          variant="ghost"
        >
          <ChevronLeft className="size-4" />
          {t("panelBack")}
        </Button>
        <span
          className="text-foreground truncate text-[13.5px] font-semibold"
          data-testid="section-panel-title"
        >
          {title}
        </span>
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto px-[18px] pt-[18px] pb-10">
        {children}
      </div>
    </React.Fragment>
  );
}

export default SectionPanel;
